import { ZoneType } from '@slot-matrix/shared-types';
/**
 * Calculate KPI metrics from slotting assignments and warehouse data.
 */
export function calculateKPIs(assignments, skus, locations, zones, _segments) {
    const totalSkus = skus.length;
    // Alignment score: % SKUs in optimal zone (impact score ≥ 50 or unassigned)
    const alignedSkus = assignments.filter((a) => a.impactScore >= 50 || !a.currentLocationId).length;
    const alignmentScore = totalSkus > 0 ? (alignedSkus / totalSkus) * 100 : 0;
    // Golden zone utilization
    const goldenZoneLocations = locations.filter((l) => zones.find((z) => z.id === l.zoneId)?.type === ZoneType.GoldenZone);
    const goldenZoneFilledWithA = goldenZoneLocations.filter((l) => {
        const assignment = assignments.find((a) => a.recommendedLocationId === l.id);
        if (!assignment)
            return false;
        return assignment.segment.startsWith('A');
    }).length;
    const goldenZoneUtilization = goldenZoneLocations.length > 0 ? (goldenZoneFilledWithA / goldenZoneLocations.length) * 100 : 0;
    // Travel reduction
    const totalTravelReduction = assignments.reduce((sum, a) => sum + a.travelReduction, 0);
    const avgTravelReduction = assignments.length > 0 ? totalTravelReduction / assignments.length : 0;
    const travelReduction = Math.max(0, Math.min(100, avgTravelReduction));
    // Space utilization
    const totalCapacity = locations.reduce((sum, l) => sum + l.weightCapacity, 0);
    const usedCapacity = assignments.reduce((sum, a) => {
        const sku = skus.find((s) => s.id === a.skuId);
        return sum + (sku?.weight ?? 0);
    }, 0);
    const spaceUtilization = totalCapacity > 0 ? (usedCapacity / totalCapacity) * 100 : 0;
    // Average distance per pick
    const weightedDistances = assignments.map((a) => {
        const loc = locations.find((l) => l.id === a.recommendedLocationId);
        if (!loc)
            return 0;
        const zone = zones.find((z) => z.id === loc.zoneId);
        return zone?.distanceScore ?? 0;
    });
    const averageDistancePerPick = weightedDistances.length > 0
        ? weightedDistances.reduce((sum, d) => sum + d, 0) / weightedDistances.length
        : 0;
    // Classified SKUs
    const classifiedSkus = assignments.length;
    // Total moves
    const totalMoves = assignments.filter((a) => a.currentLocationId && a.currentLocationId !== a.recommendedLocationId).length;
    // High impact moves
    const highImpactMoves = assignments.filter((a) => a.impactScore > 70).length;
    return {
        alignmentScore,
        travelReduction,
        goldenZoneUtilization,
        averageDistancePerPick,
        spaceUtilization,
        totalSkus,
        classifiedSkus,
        totalMoves,
        highImpactMoves,
    };
}
//# sourceMappingURL=kpiCalculator.js.map